import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class GlobalContentService {

  baseUrl = environment.baseUrl;

  global_content_form = new FormGroup({
    id: new FormControl(null),
    header_content: new FormControl(''),
    body_content: new FormControl(''),
    footer_content: new FormControl(''),
  });

  constructor(private http: HttpClient) { }

  get_global_content() {
    //console.log(this.baseUrl + '/global-content');
    return this.http.get(this.baseUrl + '/global-content');
  }

  update_global_content(formData: any) {
    //console.log(formData);
    return this.http.post(this.baseUrl + '/global-content', {
      id: formData.id,
      head: formData.header_content,
      body: formData.body_content,
      footer: formData.footer_content
    });
  }

}
